module.exports = __webpack_public_path__ + "img/parking-icon.2562d5f6.svg";